/**
 * Form Fields Validation
 * @version 1.0
 * @author Bikash Limbu
 * @copyright Kuki Ventures Ltd 2020
 */
const FormValidation = (() => {
    let validationError = 0;

    /**
     * Display/hide error messages based on the validation error
     * @param fieldContainer
     * @param fieldErrorMessage
     */
    const showValidationsError = function(fieldContainer, fieldErrorMessage) {
        const validationErrorMessages = fieldContainer.getElementsByClassName('validation-error');
        if (fieldErrorMessage) {
            // Remove existing error message element to be replaced by the new error message
            Array.from(validationErrorMessages).forEach(error => error.remove());
            // Add the error message below the field with error on the form
            const fieldErrorMessageHTML = `<div class="validation-error" aria-live="polite">${fieldErrorMessage}</div>`;
            fieldContainer.insertAdjacentHTML('beforeend', fieldErrorMessageHTML);
        } else {
            // Remove the error message if it already exists and the error has been resolved on the form
            Array.from(validationErrorMessages).forEach(error => error.remove());
        }
    }

    /**
     * Validation rules according to form field types
     * @type {phone, invoice_amount, required, email}
     */
    const validations = {
        required: function(value){
            return value !== '';
        },
        invoice_amount: function(value){
             return value.match(/^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(\.[0-9][0-9])?$/);
        },
        phone: function(value){
            return value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
        },
        email: function(value){
            return value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        }
    }

    /**
     *  Validate individuals field of the form
     * @param field
     * @param errorCounter
     */
    const validateFormFields = (field, errorCounter = false) => {
        const fieldContainer = field.parentNode;
        // check whether the form field is a dropdown button or other formal fields
        const fieldValue = field.tagName === 'A' && field.classList.contains('dropdown__button')
            ? field.getAttribute('data-value')
            : field.value;
        const fieldName = field.name;

        const checkFields = [
            {
                checkValidation: 'required',
                value: fieldValue
            },
            {
                checkValidation: fieldName,
                value: fieldValue
            }
        ];

        let fieldErrorMessage;
        checkFields.forEach((validationRule) => {
            if (validations.hasOwnProperty(validationRule.checkValidation)) {
                const validationResult = validations[validationRule.checkValidation](validationRule.value);

                if (validationRule.checkValidation === 'required' && validationResult === false) {
                    fieldErrorMessage = 'This field is required.';
                } else if (validationRule.value && (validationRule.checkValidation !== 'required' && validationResult === null)) {
                    switch (validationRule.checkValidation) {
                        case 'email':
                            fieldErrorMessage = 'Please enter a valid email address.';
                            break;
                        case 'phone':
                            fieldErrorMessage = 'Please enter a valid phone number.';
                            break;
                        default:
                            fieldErrorMessage = 'Please enter a valid amount.';
                    }
                }
            }
        });

        if (fieldErrorMessage && errorCounter) {
            // Count the number of fields with validation error
            validationError++;
        }

        showValidationsError(fieldContainer, fieldErrorMessage);
    }

    /**
     * Validate whole form - used on the form submission
     * @param formFields
     * @param dropdownButtonSelect
     */
    const formValidation = function(formFields, dropdownButtonSelect) {
        // Each time reset the number of fields with validation error before the start of checking
        validationError = 0;

        formFields.forEach((field) => {
            // If the field is a select element then use dropdown select button
            // This is because the default form select is overwritten by the js dropdown select button
            const requiredField = field.tagName === 'SELECT' ? dropdownButtonSelect : field;
            validateFormFields(requiredField, true);
        });
    }

    return {
        formValidation,
        validateFormFields,
        showValidationsError,
        validationError
    }
})();
export default FormValidation;
